module.exports = __webpack_public_path__ + "img/icon_logo@2x.00937a80.png";